<div class="main-wrapper">
    <app-dialog></app-dialog>
    <app-message-dialog></app-message-dialog>
    <app-confirmation-dialog></app-confirmation-dialog>
    <router-outlet></router-outlet>
    <app-tooltip-main></app-tooltip-main>
</div>